module.exports = __webpack_public_path__ + "static/media/heart-yellow.79c812a8.webp";